import axiosClient from "api/axios_client.js";

const apiAuditTrail = {
  getAll: (payload) => axiosClient.post(`/email-management/audit-trail/get-all`, payload),
  getById: (id) => axiosClient.get(`/email-management/audit-trail/get-by-id/${id}`),

};

export default apiAuditTrail;

